<template>
	<neko-data-list :data="getCabinetsData" :options="cabinetsDataListOptions">
		<template #default="{ element }">
			<td>
				<span class="icon-text">
					<span v-if="element && value && element.id === value.id" class="icon">
						<fa icon="check-circle" />
					</span>
					<span>{{ element.name }}</span>
				</span>
			</td>
		</template>
	</neko-data-list>
</template>

<script lang="ts">
import { Getter } from "vuex-class";
import { Component, Prop, Vue } from "vue-property-decorator";
import { DataListOptions, DataListParams, DataListResponse } from "@emasofts/common-vuejs-datalist";

import { Cabinet } from "@/lib/keycloak/typings/EmaSoftsToken";

import { DataList as NekoDataList } from "@/components/dataList";

@Component({
	components: {
		NekoDataList
	}
})
export default class CabinetSelector extends Vue {
	@Prop()
	public value!: Cabinet;

	@Getter("login/cabinets")
	public cabinets!: Cabinet[];

	public cabinetsDataListOptions: DataListOptions = {
		callbackClickRow: (cabinet: Cabinet) => {
			this.$emit("input", cabinet);
		},
		displayLengthDefault: 10,
		refreshShow: false
	};

	public async getCabinetsData(params: DataListParams): Promise<DataListResponse<Cabinet>> {
		const data: Cabinet[] =
			this.cabinets
				.filter(cabinet => cabinet.name.toUpperCase().includes(params.search.toUpperCase()))
				.sort((a, b) => (a.name === b.name ? 0 : a.name < b.name ? -1 : 1)) || [];

		return {
			draw: params.draw,
			recordsTotal: data.length,
			data: data.slice(params.start, params.start + params.length)
		};
	}
}
</script>
